<template>
  <div class="lot-card d-flex flex-column flex-lg-row align-items-lg-center">
    <div class="text-neutral-600 mr-5">
      {{ lot.name }}
    </div>

    <span class="text-positive-600 functional-1 d-lg-none">
      R$ {{ formatMoney(lot.price) }}
    </span>

    <div class="divider" />
    <div class="d-flex align-items-center gap-3">
      <bp-tooltip
        size="14"
        text="Ingresso por lote, atrelado ao final da venda de outro ingresso"
        :disabled="!lot.parent_id"
      >
        <bp-icon
          class="text-primary-400"
          icon="fa-solid fa-tickets-perforated"
        />
      </bp-tooltip>
      <span class="functional-1 text-neutral-400">{{ lot.stock }}</span>
    </div>

    <div class="divider" />
    <span class="text-positive-600 functional-1 d-none d-lg-inline">
      R$ {{ formatMoney(lot.price) }}
    </span>

    <div class="divider" />
    <div class="d-flex flex-column flex-lg-row text-neutral-400 functional-1">
      <div v-if="lot.start_at">
        <span class="d-lg-none">Início: </span>
        {{ formatDate(lot.start_at) }}
      </div>
      <div v-if="lot.start_at" class="d-none d-lg-inline">-</div>
      <div>
        <span class="d-lg-none">Término: </span>
        {{ formatDate(lot.end_at) }}
      </div>
    </div>

    <div class="flex-fill" />

    <div class="d-flex gap-5 flex-column flex-lg-row mt-6 mt-lg-0">
      <bp-button
        block
        size="sm"
        color="neutral"
        variant="filled-1"
        icon="fa-regular fa-pen"
        :label="isMobile && 'Editar'"
        @click="$emit('edit')"
      />
      <bp-button
        v-if="!hasChildren"
        block
        size="sm"
        color="negative"
        variant="filled-1"
        icon="fa-regular fa-trash"
        :label="isMobile && 'Excluir'"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>
<script>
import { formatMoney } from "@/functions/helpers";
export default {
  props: {
    lot: {
      type: Object,
      default: () => ({})
    },
    hasChildren: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({ isMobile: window.innerWidth < 992 }),
  methods: {
    formatMoney,
    formatDate(date) {
      return date.split(" ")[0];
    }
  }
};
</script>
<style lang="scss" scoped>
.lot-card {
  background-color: #fdfefe;
  border: 1px solid $neutral-100;
  border-radius: 4px;
  padding: 20px;
  width: 100%;
  gap: 4px;

  .divider {
    background-color: $neutral-300;
    border-radius: 50%;
    height: 16px;
    margin: 0 16px;
    width: 1px;
    @media screen and (max-width: 991px) {
      display: none;
    }
  }
}
</style>
